<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-form-select
        v-model="answer"
        :options="selectOptions"
        @change="handleAnswerChange"
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountSingle",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    preAnswer: {
      type: String,
      default: "",
    },
    answerList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    selectOptions() {
      let selectOptions = [];
      for (let answer of this.answerList) {
        selectOptions.push({ value: answer.id, text: answer.name });
      }
      return selectOptions;
    },
  },
  mounted() {
    let next = this.body.next;
    if (this.preAnswer) {
      let answer = this.answerList.find((o) => o.name == this.preAnswer);
      this.answer = answer.id;
      if (answer.hasOwnProperty("next")) {
        next = answer.next;
      }
    }
    this.$emit("load-next", next);
  },
  data() {
    return {
      answer: null,
    };
  },
  methods: {
    handleAnswerChange() {
      let answerCheck = this.answerList.find(
        (o) => o.id == this.answer && o.hasOwnProperty("next")
      );
      if (answerCheck) {
        this.$emit("load-next", answerCheck.next, this.body.id);
        return;
      }
      this.$emit("load-next", this.body.next, this.body.id);
    },
  },
};
</script>

<style></style>
